export const aboutData = {
  brandName: '俄罗斯妈妈',
  tagline: '走进真实的俄罗斯妈妈世界',
  story: '「俄罗斯妈妈」创办于2020年，由一群对俄罗斯家庭文化充满热情的中俄文化交流者共同发起。我们的使命是搭建一座桥梁，让中文世界的读者能够深入了解俄罗斯妈妈的真实生活、育儿理念与家庭文化。',
  mission: '我们相信，每一种文化中的母性都有其独特的智慧与光芒。通过分享俄罗斯妈妈的故事，我们希望促进跨文化理解，让更多家庭在全球化时代汲取不同文化的育儿精华。',
  values: [
    {
      title: '真实故事',
      description: '我们坚持分享真实的俄罗斯妈妈故事，拒绝刻板印象与标签化叙事。每一位妈妈的故事都是独特的，都值得被认真聆听。',
      icon: 'ri-user-heart-line',
    },
    {
      title: '文化桥梁',
      description: '我们致力于成为中俄家庭文化交流的桥梁，帮助中文读者理解俄罗斯家庭文化的深层逻辑与温度。',
      icon: 'ri-global-line',
    },
    {
      title: '深度内容',
      description: '每一篇文章都经过精心研究与创作，确保内容的深度与准确性，为读者提供真正有价值的育儿与家庭文化知识。',
      icon: 'ri-article-line',
    },
    {
      title: '温暖社区',
      description: '我们正在建设一个温暖、包容的社区，让对俄罗斯文化感兴趣的朋友们可以在这里交流、分享与成长。',
      icon: 'ri-group-line',
    },
  ],
  stats: [
    { value: '200+', label: '原创文章' },
    { value: '50,000+', label: '月度读者' },
    { value: '12', label: '核心作者' },
    { value: '6', label: '内容专栏' },
  ],
  contact: {
    email: 'hello@russianmama.cn',
    wechat: 'RussianMama_Official',
    address: '北京市朝阳区建国路88号SOHO现代城A座',
  },
};